const pageNameKey = "patchTicketStatusDropdown";

export const patchTicketStatusDropdownEn = {
  [pageNameKey]: {
    labelNew: "NEW",
    labelOpen: "OPEN",
    labelPending: "PENDING",
    labelHold: "HOLD",
    labelSolved: "SOLVED",
    labelClosed: "CLOSED",
    errorUpdatingStatus: "It was not possible to update the ticket status.",
    selectStatusLabel: "Select status",
    successUpdatingStatus: "Ticket status updated successfully.",
    warningNoSolvedWithoutAssignee:
      "Only tickets with an assigned user can be marked as solved. Please assign a user to the ticket.",
  },
};

export const patchTicketStatusDropdownPtBr = {
  [pageNameKey]: {
    labelNew: "NOVO",
    labelOpen: "ABERTO",
    labelPending: "PENDENTE",
    labelHold: "EM ESPERA",
    labelSolved: "RESOLVIDO",
    labelClosed: "FECHADO",
    errorUpdatingStatus: "Não foi possível atualizar o status do ticket.",
    selectStatusLabel: "Selecionar status",
    successUpdatingStatus: "Status do ticket atualizado com sucesso.",
    warningNoSolvedWithoutAssignee:
      "Somente tickets com um usuário atribuído podem ser marcados como resolvidos. Atribua um usuário ao ticket.",
  },
};

export const patchTicketStatusDropdownDe = {
  [pageNameKey]: {
    labelNew: "NEU",
    labelOpen: "OFFEN",
    labelPending: "AUSSTEHEND",
    labelHold: "WARTEND",
    labelSolved: "GELÖST",
    labelClosed: "GESCHLOSSEN",
    errorUpdatingStatus:
      "Es war nicht möglich, den Status des Tickets zu aktualisieren.",
    selectStatusLabel: "Status auswählen",
    successUpdatingStatus: "Ticketstatus erfolgreich aktualisiert.",
    warningNoSolvedWithoutAssignee:
      "Nur Tickets mit einem zugewiesenen Benutzer können als gelöst markiert werden. Bitte weisen Sie dem Ticket einen Benutzer zu.",
  },
};

export const patchTicketStatusDropdownZhHans = {
  [pageNameKey]: {
    labelNew: "新建",
    labelOpen: "打开",
    labelPending: "待处理",
    labelHold: "暂停",
    labelSolved: "已解决",
    labelClosed: "已关闭",
    errorUpdatingStatus: "无法更新工单状态。",
    selectStatusLabel: "选择状态",
    successUpdatingStatus: "工单状态更新成功。",
    warningNoSolvedWithoutAssignee:
      "只有分配了用户的工单才能标记为已解决。请为工单分配一个用户。",
  },
};

export const patchTicketStatusDropdownIt = {
  [pageNameKey]: {
    labelNew: "NUOVO",
    labelOpen: "APERTO",
    labelPending: "IN ATTESA",
    labelHold: "IN SOSPESO",
    labelSolved: "RISOLTO",
    labelClosed: "CHIUSO",
    errorUpdatingStatus:
      "Non è stato possibile aggiornare lo stato del ticket.",
    selectStatusLabel: "Seleziona stato",
    successUpdatingStatus: "Stato ticket aggiornato con successo.",
    warningNoSolvedWithoutAssignee:
      "Solo i ticket con un utente assegnato possono essere contrassegnati come risolti. Assegna un utente al ticket.",
  },
};

export const patchTicketStatusDropdownEs = {
  [pageNameKey]: {
    labelNew: "NUEVO",
    labelOpen: "ABIERTO",
    labelPending: "PENDIENTE",
    labelHold: "EN PAUSA",
    labelSolved: "RESUELTO",
    labelClosed: "CERRADO",
    errorUpdatingStatus: "No fue posible actualizar el estado del ticket.",
    selectStatusLabel: "Seleccionar estado",
    successUpdatingStatus: "Estado del ticket actualizado correctamente.",
    warningNoSolvedWithoutAssignee:
      "Solo los tickets con un usuario asignado se pueden marcar como resueltos. Asigna un usuario al ticket.",
  },
};

export const patchTicketStatusDropdownNl = {
  [pageNameKey]: {
    errorUpdatingStatus:
      "Het was niet mogelijk om de ticketstatus bij te werken.",
    labelClosed: "GESLOTEN",
    labelHold: "IN DE WACHT",
    labelNew: "NIEUW",
    labelOpen: "OPEN",
    labelPending: "IN AFWACHTING",
    labelSolved: "OPGELOST",
    selectStatusLabel: "Status selecteren",
    successUpdatingStatus: "Ticketstatus succesvol bijgewerkt.",
    warningNoSolvedWithoutAssignee:
      "Alleen tickets met een toegewezen gebruiker kunnen als opgelost worden gemarkeerd. Wijs een gebruiker toe aan het ticket.",
  },
};

export const patchTicketStatusDropdownTr = {
  [pageNameKey]: {
    errorUpdatingStatus: "Bilet durumunu güncellemek mümkün olmadı.",
    labelClosed: "KAPALI",
    labelHold: "TUTMAK",
    labelNew: "YENİ",
    labelOpen: "AÇIK",
    labelPending: "ASKIDA OLMASI",
    labelSolved: "ÇÖZÜLDÜ",
    selectStatusLabel: "Durum seç",
    successUpdatingStatus: "Bilet durumu başarıyla güncellendi.",
    warningNoSolvedWithoutAssignee:
      "Yalnızca atanmış bir kullanıcıya sahip biletler çözülmüş olarak işaretlenebilir. Lütfen bilete bir kullanıcı atayın.",
  },
};
